import { bottomCarouselMappings } from './gridMappings';
import Image from 'next/image';

const SectionStores = () => {
  return (
    <div className="container">
      <h3 className="tw-font-bold tw-text-4xl tw-mb-8 tw-tracking-tighter tw-text-gray-800">
        Hier sind einige unserer Geschäfte. Finden Sie heraus, ob Ihre Region noch verfügbar ist!
      </h3>

      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-8">
        {bottomCarouselMappings.map((store) => (
          <div className="">
            <div className="tw-h-40 tw-w-full tw-mb-2 position-relative">
              <Image
                fill style={{objectFit: 'cover'}}
                className="tw-h-40 tw-w-full"
                src={store.img}
                alt={store.title}
              />
            </div>

            <h6 className="tw-text-xl tw-font-bold tw-tracking-tighter tw-m-0">
              {store.title}
            </h6>

            <div className="tw-text-base tw-font-medium tw-tracking-tight tw-m-0">
              {store.subtitle}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStores;
